import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  const linkStyle = { color: '#005CA9', marginRight: '1rem' };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      // Sprawdza, czy użytkownik przewinął do końca strony
      setIsAtBottom(scrollTop + windowHeight >= docHeight - 5); // -5 dla tolerancji
    };

    window.addEventListener('scroll', handleScroll);
    // Nie wywołuj handleScroll() od razu przy ładowaniu na mobile - footer ma być ukryty początkowo

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <footer className="footer" style={{ 
      backgroundColor: '#f5f5f5', 
      display: "flex", 
      alignContent:"center", 
      padding: '0.25rem', 
      fontSize: "14px", 
      width: "100%", 
      position: "fixed", 
      bottom: 'env(safe-area-inset-bottom, 0px)', 
      zIndex: 20, 
      opacity: isAtBottom ? 1 : 0, 
      pointerEvents: isAtBottom ? 'auto' : 'none', 
      transition: 'opacity 0.3s ease-out' 
    }}>
      <div className="content">
        <div className="columns is-multiline is-flex is-justify-content-flex-start">
          <div className="column is-full">
            <nav>
              <Link to="https://www.wplusm.de/Imprint" target="_blank" style={linkStyle}>
                Impressum
              </Link>
              <Link to="https://www.wplusm.de/PrivacyDisclaimer" target="_blank" style={linkStyle}>
                Datenschutz
              </Link>
              <Link to="https://wplusm.de/de/kontakt/" target="_blank" style={linkStyle}>
                Kontakt
              </Link>
              <Link to="https://www.wplusm.de/AGB" target="_blank" style={linkStyle}>
                AGB
              </Link>
              <Link to="https://www.wplusm.de/de/widerrufsbelehrung/" target="_blank" style={linkStyle}>
                Widerrufsrecht
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
